import { render, staticRenderFns } from "./CompanyContactEmailTemplatePage.vue?vue&type=template&id=5af98630&scoped=true"
import script from "./CompanyContactEmailTemplatePage.vue?vue&type=script&lang=js"
export * from "./CompanyContactEmailTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./CompanyContactEmailTemplatePage.vue?vue&type=style&index=0&id=5af98630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af98630",
  null
  
)

export default component.exports